import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const NoCreditCardIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.60002 21.7L21.7 3.60002C22.1 3.30002 22.1 2.60002 21.7 2.20002C21.3 1.80002 20.7 1.80002 20.3 2.20002L2.20002 20.3C1.80002 20.7 1.80002 21.3 2.20002 21.7C2.60002 22.1 3.20002 22.1 3.60002 21.7ZM2 3.5C1.44772 3.5 1 3.94772 1 4.5V8.8V17.1C1 17.6523 1.44772 18.1 2 18.1C2.55228 18.1 3 17.6523 3 17.1V9.8H10.8C11.3523 9.8 11.8 9.35228 11.8 8.8C11.8 8.24772 11.3523 7.8 10.8 7.8H3V5.5H15C15.5523 5.5 16 5.05228 16 4.5C16 3.94772 15.5523 3.5 15 3.5H2ZM23 6.5C23 5.94772 22.5523 5.5 22 5.5C21.4477 5.5 21 5.94772 21 6.5V7.8H19.1C18.5477 7.8 18.1 8.24772 18.1 8.8C18.1 9.35228 18.5477 9.8 19.1 9.8H21V17.5H10.1C9.54772 17.5 9.1 17.9477 9.1 18.5C9.1 19.0523 9.54772 19.5 10.1 19.5H22C22.5523 19.5 23 19.0523 23 18.5V8.8V6.5Z"
      />
    </Icon>
  );
};
